export const menuItems = {
  features: {
    generateVideos: [
      {
        title: "Reddit Story Videos",
        href: "https://crayo.ai/features/reddit-story",
        description: "Create reddit-style story videos in seconds with our AI script generator",
      },
      {
        title: "Split Screen Videos",
        href: "https://crayo.ai/features/split-screen",
        description: "Create split-screen video with our AI script generator",
      },
      {
        title: "Fake Text Stories",
        href: "https://crayo.ai/features/fake-texts",
        description: "Create fake text conversation videos for Instagram, TikTok, and Shorts",
      },
    ],
    tools: [
      { title: "AI Voiceovers", href: "https://crayo.ai/tools/voiceovers" },
      { title: "AI Images", href: "https://crayo.ai/tools/images" },
      { title: "AI Ideas", href: "https://crayo.ai/tools/ideas" },
      { title: "YouTube Downloader", href: "https://crayo.ai/tools/youtube-downloader" },
      { title: "TikTok Downloader", href: "https://crayo.ai/tools/tiktok-downloader" },
    ],
  },
  useCases: [
    {
      title: "TikTok Virality",
      href: "https://crayo.ai/dashboard",
      description: "Use Crayo's AI tools to create viral TikTok content.",
    },
    {
      title: "YouTube Automation",
      href: "https://crayo.ai/dashboard",
      description: "Automate YouTube content creation to save time and boost productivity.",
    },
    {
      title: "Faceless Content",
      href: "https://crayo.ai/dashboard",
      description: "Create engaging faceless videos with AI voiceovers.",
    },
    {
      title: "Instagram Monetization",
      href: "https://crayo.ai/dashboard",
      description: "Boost Instagram earnings with eye-catching Reels and Stories.",
    },
    {
      title: "Subtitles",
      href: "https://crayo.ai/dashboard",
      description: "Add accurate subtitles quickly using AI-powered generation.",
    },
  ],
  resources: [
    {
      title: "Affiliate Program",
      href: "https://crayo.tolt.io/login",
      description: "Earn 20% on all paid referrals to Crayo.",
    },
    {
      title: "Blog",
      href: "https://crayo.ai/blog",
      description: "Find news, insights, and best practices.",
    },
    {
      title: "Community Discord",
      href: "https://crayo.ai/discord",
      description: "Join for customer support and feedback.",
    },
  ],
};
